import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class SettingsDepartmentsIndexRoute extends Route {
  @service router;

  beforeModel() {
    this.router.transitionTo('settings.departments.list');
  }
}

export default instrumentRoutePerformance(SettingsDepartmentsIndexRoute);
